module.exports = "/_next/static/images/avatar-frame-tier-3--simple-5eeb1ad0d1f39156db4fbc28a132bb82.png";